import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store/index";
import ApiShippingAddress from "@/api/ApiShippingAddress";

import {
  ShippingAddressListResponse,
  ShippingAddressResponse,
} from "@API/src/component/memoruHome/shippingAddress/types";
import {
  DeleteShippingAddressRequest,
  FetchShippingAddressListRequest,
  PostShippingAddressRequest,
  PutShippingAddressRequest,
} from "@/model/request/shippingAddress";

export interface ShippingAddressState {
  shippingAddressList: ShippingAddressListResponse | null;
}

@Module({ dynamic: true, store, name: "shippingAddress", namespaced: true })
class ShippingAddressModule extends VuexModule implements ShippingAddressState {
  public shippingAddressList: ShippingAddressListResponse | null = null;

  @Action({ rawError: true })
  public async fetchShippingAddressList(
    request: FetchShippingAddressListRequest
  ) {
    const response: ShippingAddressListResponse =
      await ApiShippingAddress.fetchShippingAddressList(request);
    this.setShippingAddressList(response);
    return response;
  }

  @Mutation
  public setShippingAddressList(
    shippingAddressList: ShippingAddressListResponse
  ) {
    this.shippingAddressList = shippingAddressList;
  }

  @Action({ rawError: true })
  public async postShippingAddress(request: PostShippingAddressRequest) {
    await ApiShippingAddress.postShippingAddress(request);
    return true;
  }

  @Mutation
  public addShippingAddress(shippingAddress: ShippingAddressResponse) {
    if (this.shippingAddressList) {
      this.shippingAddressList = [...this.shippingAddressList, shippingAddress];
    }
  }

  @Action({ rawError: true })
  public async putShippingAddress(request: PutShippingAddressRequest) {
    const response = await ApiShippingAddress.putShippingAddress(request);
    this.changeShippingAddress(response);
    return true;
  }

  @Mutation
  public changeShippingAddress(shippingAddress: ShippingAddressResponse) {
    if (this.shippingAddressList) {
      this.shippingAddressList = this.shippingAddressList.map((list) => {
        if (list.shippingAddressId === shippingAddress.shippingAddressId) {
          return shippingAddress;
        }
        return list;
      });
    }
  }

  @Action({ rawError: true })
  public async deleteShippingAddress(request: DeleteShippingAddressRequest) {
    await ApiShippingAddress.deleteShippingAddress(request);
    // if (response.data && response.data)
    this.removeShippingAddress(request.shippingAddressId);
    return true;
  }

  @Mutation
  public removeShippingAddress(shippingAddressId: number) {
    if (this.shippingAddressList) {
      this.shippingAddressList = this.shippingAddressList.filter((list) => {
        if (list.shippingAddressId !== shippingAddressId) {
          return list;
        }
      });
    }
  }
}

export const shippingAddressModule = getModule(ShippingAddressModule);
